module.exports = __webpack_public_path__ + "img/football.1cf64316.jpg";